module.exports = __webpack_public_path__ + "static/media/BR-colored.087b81b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/BR-colored.svg
// module id = 4021
// module chunks = 0